import { render, staticRenderFns } from "./RunningChat.vue?vue&type=template&id=6bc273d3&scoped=true&"
import script from "./RunningChat.vue?vue&type=script&lang=js&"
export * from "./RunningChat.vue?vue&type=script&lang=js&"
import style0 from "./RunningChat.vue?vue&type=style&index=0&id=6bc273d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc273d3",
  null
  
)

export default component.exports